import { Box } from "@primer/react";
import { Outlet, useLocation } from "react-router-dom";
import { useIsMobile } from "../hooks/useIsMobile";
import Footer from "./Footer";
import Header from "./Header";

/**
 * App shell — Header (sticky top) + main content (Outlet) + Footer.
 * Wrapped trong ProtectedRoute ở routers.tsx — chỉ render khi user đã đăng nhập.
 */
const Layout = () => {
    const isMobile = useIsMobile();
    const { pathname } = useLocation();
    // Trang đăng ký bản mobile là app-shell có thanh tab dưới — thông tin liên hệ/hỗ trợ
    // đã chuyển vào tab "Hỗ trợ" → ẩn footer ở đây. Footer vẫn hiện ở các trang mobile khác.
    const hideFooter = isMobile && pathname.startsWith("/classes");

    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bg: "canvas.inset" }}>
            <Header />
            <Box as="main" sx={{ flex: 1 }}>
                <Outlet />
            </Box>
            {!hideFooter && <Footer />}
        </Box>
    );
};

export default Layout;
